import * as React from "react";
import { Control, useController } from "react-hook-form";

import CommentIcon from "@mui/icons-material/Comment";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import type { SxProps } from "@mui/material/styles";

import { PatientFormValues } from "../patient-form.component";

type PrimaryContactNotesProps = {
  control: Control<PatientFormValues, object>;
  sx?: SxProps;
};

export default function PrimaryContactNotesField({
  control,
  sx
}: PrimaryContactNotesProps) {
  const {
    field,
    formState: { errors }
  } = useController({
    name: "primary_contact_notes",
    control
  });
  return (
    <Box display="flex" justifyContent="space-between" sx={sx}>
      <CommentIcon sx={{ mt: "30px", mr: 1.5 }} />
      <TextField
        fullWidth
        label="Primary Contact Notes"
        {...(Boolean(errors?.primary_contact_notes?.message)
          ? { error: true, helperText: errors?.primary_contact_notes?.message }
          : {})}
        {...field}
      />
    </Box>
  );
}
